import { EncryptionContextProvider } from "./config/context/encryptionContext";
import { GuiContextProvider } from "./config/context/guiContext";
import { IDBProvider } from "./config/context/IDBcontext";
import { PluginsContextProvider } from "./config/context/pluginsContext";
import { PrivateKeyContextProvider } from "./config/context/privateKeyContext";
import { TableContextProvider } from "./config/context/tableContext";
import { ThemeContextProvider } from "./config/context/themeContext";
import { ToastContextProvider } from "./config/context/toastContext";
import { ModalContextProvider } from "config/context/modalContext";
import { AuthenticationContextProvider } from "config/context/authenticationContext";
import { ModalSystemProvider } from "config/context/ModalSystemContext";

/**
 * Provajderi koje aplikacija traži, na jednom mestu.
 *
 * Stajali su u `index.js`, pa se `<App />` nije mogao iscrtati nigde drugde —
 * ni u testu, jer bi prvi kontekst koji nedostaje oborio celo stablo. Redosled
 * je zadržan tačno kakav je bio: `GuiContext` mora iznad onih koji ga čitaju,
 * `AuthenticationContext` iznad `PrivateKeyContext`, i tako redom.
 */
const AppProviders = ({ children }) => (
  <IDBProvider>
    <GuiContextProvider>
      <TableContextProvider>
        <ToastContextProvider>
          <ThemeContextProvider>
            <ModalContextProvider>
              <ModalSystemProvider>
                <AuthenticationContextProvider>
                  <PrivateKeyContextProvider>
                    <PluginsContextProvider>
                      <EncryptionContextProvider>
                        {children}
                      </EncryptionContextProvider>
                    </PluginsContextProvider>
                  </PrivateKeyContextProvider>
                </AuthenticationContextProvider>
              </ModalSystemProvider>
            </ModalContextProvider>
          </ThemeContextProvider>
        </ToastContextProvider>
      </TableContextProvider>
    </GuiContextProvider>
  </IDBProvider>
);

export default AppProviders;
